import React, { Component } from "react";
import { connect } from "react-redux";
import { storeSelectedDate } from '../../../../SHARED/actions/filters.actions';
import moment from 'moment';

class ScheduleDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDay: moment().format('DD')
        };
    }

    componentWillMount() {
        this.props.storeSelectedDate(moment().format('YYYY-MM-DD'));
    }

    getDates() {
        let dates = [];
        let i;
        for (i = 0; i <= 6; i++) {
            let now = moment().locale('ro');
            dates.push(now.add(i, 'days'))
        }

        let formatedDates = [];
        for (i = 0; i < 7; i++) {
            formatedDates.push({
                id: i + 1,
                day: dates[i].format('DD'),
                dayString: dates[i].format('dd'),
                month: dates[i].format('MMM'),
                fullDate: dates[i]
            });
        }
        return formatedDates;
    }

    changeSelectedDay(date) {
        this.setState({
            selectedDay: date.date.day
        });
        //GET DATA FROM API
        let formatedDate = date.date.fullDate.format('YYYY-MM-DD');
        this.props.storeSelectedDate(formatedDate);
        this.props.onDateChanged(formatedDate);
    }

    showDates(date) {
        let isSelected = false;
        if (date.day === moment().format('DD')) {
            date.dayString = 'Azi';
        }
        if (date.day === this.state.selectedDay) {
            isSelected = true;
        }
        if (isSelected) {
            return <div key={date.id} className="col">
                <div className="date-item">
                    <div className="date-title  middle text-center">{date.dayString}</div>
                    <div className="date-body middle center">
                        <div>{date.day}</div>
                        <div className="month">{date.month}</div>
                    </div>
                </div>
            </div>
        } else {
            return <div key={date.id} className="col" onClick={this.changeSelectedDay.bind(this, { date })}>
                <div className="date-item">
                    <div className="date-title-different  middle text-center">{date.dayString}</div>
                    <div className="date-body-different middle center">
                        <div>{date.day}</div>
                        <div className="month">{date.month}</div>
                    </div>
                </div>
            </div>
        }
    }

    render() {
        let dates = this.getDates();
        return (
            <div className="date-container row no-gutters">
                {dates.map(this.showDates, this)}
            </div>

        );
    }
}

const mapStateToProps = state => ({});
export default connect(
    mapStateToProps,
    {storeSelectedDate}
)(ScheduleDate);



// WEBPACK FOOTER //
// ./src/FO/components/schedule/containers/scheduledates.component.js